import React, { useState } from 'react';
import Appearance from 'styles/Appearance.js';
import Utils from 'files/Utils.js';
import Button from 'views/Button.js';
import Request from 'files/Request.js';

// Waitlist capture for areas with no online sales and no nearby dealer.
// Framed around expansion: the signup tells us where to focus next.
//
// Backend: Request.post(utils, '/shop/', { type: 'notify_when_available', ... })
const NotifyModal = ({ open, onClose, utils }) => {

    const [email, setEmail] = useState('');
    const [zip, setZip] = useState('');
    const [status, setStatus] = useState('idle'); // idle | submitting | done | error
    const [error, setError] = useState(null);

    if(!open) {
        return null;
    }

    const onSubmit = async (e) => {
        if(e) { e.preventDefault(); }
        if(status === 'submitting') {
            return;
        }
        setStatus('submitting');
        setError(null);
        try {
            await Request.post(utils, '/shop/', {
                type: 'notify_when_available',
                email_address: email,
                zip_code: zip,
            });
            setStatus('done');
        } catch(err) {
            setError((err && err.message) || 'Something went wrong. Please try again.');
            setStatus('error');
        }
    };

    const fieldStyle = {
        fontFamily: Appearance.fonts.body,
        fontSize: 15,
        padding: '13px 16px',
        borderRadius: 12,
        border: `1px solid ${Appearance.colors.border()}`,
        backgroundColor: Appearance.colors.white,
        color: Appearance.colors.text(),
        outline: 'none',
        width: '100%',
    };

    return (
        <div
            onClick={onClose}
            style={{
                position: 'fixed',
                inset: 0,
                zIndex: 1000,
                backgroundColor: 'rgba(0,0,0,0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 20,
                animation: 'fadeIn 0.28s ease',
            }}>
            <div
                onClick={(e) => e.stopPropagation()}
                style={{
                    position: 'relative',
                    width: '100%',
                    maxWidth: 440,
                    backgroundColor: Appearance.colors.white,
                    borderRadius: 24,
                    boxShadow: Appearance.boxShadow.cardHover,
                    padding: Utils.isMobile() ? '36px 26px' : '44px 40px',
                    textAlign: 'center',
                    animation: 'scaleIn 0.3s ease both',
                }}>

                {/* Close */}
                <div
                    onClick={onClose}
                    style={{
                        position: 'absolute', top: 16, right: 16,
                        width: 32, height: 32, borderRadius: 16,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        cursor: 'pointer', color: Appearance.colors.subText(),
                    }}>
                    <i className={'fas fa-times'} style={{ fontSize: 16 }} />
                </div>

                {status === 'done' ? (
                    <>
                        <div style={{
                            width: 56, height: 56, borderRadius: '50%',
                            backgroundColor: Utils.hexToRGBA(Appearance.colors.success, 0.15),
                            display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 18px',
                        }}>
                            <i className={'fas fa-check'} style={{ fontSize: 22, color: Appearance.colors.success }} />
                        </div>
                        <h3 style={{ ...Appearance.textStyles.heading({ fontSize: 24 }), marginBottom: 10 }}>{'You\'re on the list'}</h3>
                        <p style={Appearance.textStyles.body()}>
                            {'Thanks! We\'re expanding fast — the moment Aqua Link is available in your area, you\'ll be the first to know.'}
                        </p>
                    </>
                ) : (
                    <>
                        <div style={{
                            width: 56, height: 56, borderRadius: 28,
                            backgroundColor: Utils.hexToRGBA(Appearance.colors.primary(), 0.12),
                            display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 14,
                        }}>
                            <i className={'fas fa-map-marker-alt'} style={{ fontSize: 22, color: Appearance.colors.primary() }} />
                        </div>
                        <h3 style={{ ...Appearance.textStyles.heading({ fontSize: Utils.isMobile() ? 24 : 28 }), marginBottom: 10 }}>
                            {'We\'re coming to your area'}
                        </h3>
                        <p style={{ ...Appearance.textStyles.body(), marginBottom: 22 }}>
                            {'Aqua Link is growing quickly. Leave your details and we\'ll notify you the moment service reaches you — your interest helps us decide where to expand next.'}
                        </p>

                        <form onSubmit={onSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                            <input
                                type={'email'}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder={'you@email.com'}
                                required={true}
                                style={fieldStyle} />
                            <input
                                type={'text'}
                                value={zip}
                                onChange={(e) => setZip(e.target.value)}
                                placeholder={'ZIP code'}
                                inputMode={'numeric'}
                                required={true}
                                style={fieldStyle} />

                            {error && (
                                <span style={Appearance.textStyles.caption({ color: Appearance.colors.error })}>{error}</span>
                            )}

                            <Button
                                label={'Join Waitlist'}
                                type={'primary'}
                                loading={status === 'submitting'}
                                onClick={() => {}}
                                style={{ padding: '14px 24px', fontSize: 16, width: '100%' }} />
                        </form>
                    </>
                )}
            </div>
        </div>
    );
};

export default NotifyModal;
